import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AddressSearchContext } from '/src/App';
import LogUserAddressSearch from '/src/services/Logging/LogUserAddressSearch';
import axios from "axios";


const AddressSearchHandler = () => {
    const navigate = useNavigate();
    const { addressSearchModelingTracker, setAddressSearchModelingTracker, user } = useContext(AddressSearchContext);

    const handleAddressExistanceCheck = async (placeId, handlerKey) => {
        // console.log('handleAddressExistanceCheck', placeId, handlerKey);
        const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

        const userId = user?.user_id || null;
        const userSessionId = user?.sessionId || null;

        let userIdToUse = userId || userSessionId || 'Quoll';

        // console.log('userIdToUse', userIdToUse);

        try {
            const response = await axios.post(
                `${apiBaseUrl}/check-address-availability`,
                {
                    [handlerKey]: placeId,
                    user_id: userIdToUse
                }
            );
            // console.log('Response:', response.data);
            const responseData = response.data;
            if (responseData) {
                const propertyId = responseData.address_id;
                const addressDetailsQuoll = responseData.address_details;
                if ((responseData.status === 'pass' || responseData.status === 'confirmation_required') && propertyId) {

                    let nextStage;
                    let secondaryConformationNeeded;
                    let secondaryConfirmationReason;
                    if (responseData.status === 'pass') {
                        nextStage = 'modeling';
                        secondaryConformationNeeded = false;
                        secondaryConfirmationReason = null;
                    } else {
                        nextStage = 'secondary_confirmation';
                        secondaryConformationNeeded = true;
                        secondaryConfirmationReason = responseData.reason;
                    }
                    setAddressSearchModelingTracker(prevState => ({
                        ...prevState,
                        processStage: nextStage,
                        secondaryConfirmationRequired: secondaryConformationNeeded,
                        secondaryConfirmationReason: secondaryConfirmationReason,
                        quollPropertyId: propertyId,
                        addressDetailsQuoll: addressDetailsQuoll
                    }));
                    // We need to log the user search for the property
                    const sessionIdToUse = user?.sessionId || null;
                    const puidToUse = user?.puid || null;

                    // We need to log the user search for the property
                    const logObject = {
                        property_id: propertyId,
                        first_time_search: true,
                        user_id: puidToUse,
                        session_id: sessionIdToUse
                    }
                    LogUserAddressSearch(logObject);

                    return { result: true, quollPropertyId: propertyId };
                } else {
                    // console.log('Address is not available', responseData);
                    return { result: false };
                }
            } else {
                // console.log('No response from address existence check', responseData);
                return { result: false };
            }
        } catch (error) {
            // console.error('Error:', error);
            return { result: false };
        }
    }

    // useEffect to check for address availability before sending to property explorer
    useEffect(() => {
        const checkAddress = async () => {
            if (addressSearchModelingTracker.searchInProgress && addressSearchModelingTracker.processStage === 'initial') {
                // console.log('addressSearchModelingTracker FROM SECONDARY CHECK', addressSearchModelingTracker);

                // Determine which id to use based on the search type and the key for the handler to use
                const placeId = addressSearchModelingTracker.searchType === 'input' ? addressSearchModelingTracker.googlePlaceId : addressSearchModelingTracker.quollPropertyId;
                const handlerKey = addressSearchModelingTracker.searchType === 'input' ? 'address_id' : 'quoll_property_id';

                const addressExistanceCheckResult = await handleAddressExistanceCheck(placeId, handlerKey);
                if (addressExistanceCheckResult.result) {
                    // If true then we navigate to properties/quollPropertyId
                    // console.log(`Address is available, navigating to properties/${addressExistanceCheckResult.quollPropertyId}`);
                    navigate(`/properties/${addressExistanceCheckResult.quollPropertyId}/big-picture`);
                } else {
                    // If false / error then we navigate to the home page using navigate
                    // console.log('Address is not available, navigating to home page');
                    setAddressSearchModelingTracker(prevState => ({
                        ...prevState,
                        searchInProgress: false
                    }));
                    if (window.location.pathname !== '/') {
                        navigate('/');
                    }
                }
            } else {
                // console.log("Address search modeling tracker is not in the initial stage");
            }
        };

        checkAddress();
    }, [addressSearchModelingTracker]);

    return null;  // Component doesn't render anything
};

export default AddressSearchHandler;